"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.METRIC_UPDATE_QUEUE_NAME = void 0;
exports.METRIC_UPDATE_QUEUE_NAME = 'metric-update-messages';